import React from "react";
import { Skeleton } from "@/components/ui/adapters";

interface ActionListSkeletonProps {
  count?: number;
}

/** Reserves avatar, identity and action geometry while list data loads. */
const ActionListSkeleton = ({
  count = 5,
}: ActionListSkeletonProps): React.ReactElement => (
  <div className="w-full flex flex-col gap-2 flex-1 min-h-0">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="flex items-center justify-between gap-2 py-3 px-4 border-b border-gray-100 last:border-b-0"
      >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Skeleton className="size-10 rounded-full shrink-0 bg-secondary-light" />
          <div className="flex-1 min-w-0 space-y-1">
            <Skeleton className="h-4 w-2/3 max-w-[140px] rounded-md bg-secondary-light" />
            <Skeleton className="h-3 w-1/2 max-w-[100px] rounded-md bg-secondary-light" />
          </div>
        </div>
        <Skeleton className="h-10 w-24 rounded-lg shrink-0 bg-secondary-light" />
      </div>
    ))}
  </div>
);

export default ActionListSkeleton;
